module.exports = __webpack_public_path__ + "assets/img/eafc-dg.svg";